export default {
  // HOST: 'http://dev.zikto.com:3001', // 얼마야 Dev
  HOST: 'https://howmuch.zikto.com', // 얼마야 release
  // HOST: 'http://localhost:3001', // LOCAL
};